import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import instance from "services/axiosServices";

export function useCorretorParceiro(props: QueryGlobalInterface) {
  const fetchData = async () => {
    const LISTAR_ESPECIALISTAS_PRODUTO = `identity/usuario/v1/listar-especialistas-produto`;
    const response = await instance.get(LISTAR_ESPECIALISTAS_PRODUTO);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    // onError: (error: any) => {
    //   toast.error(`Erro ao buscar oportunidades. Tente novamente.`);
    //   console.error(error);
    // },
  });
  return query;
}
